module.exports = __webpack_public_path__ + "img/rgq.97dba3f0.jpg";